module.exports = __webpack_public_path__ + "static/img/triangle.2f10353.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/triangle.png
// module id = I7M2
// module chunks = 0